import Component from "../abstracts/Component";
import MenuItem from "./header/MenuItem";
import { trapFocusOnModal, removeTrapFocusOnModal } from "../utils/TrapFocus";

export default class HeaderComponent extends Component {
  get SELECTORS() {
    return {
      burgerMenu: "[data-trigger-menu]",
      searchBtn: "[data-trigger-search]",
      layersContainer: "[data-menu-layers]",
      menuItems: "[data-menu-item]",
      hpHero: "[data-hph-item]",
      benefitBar: "[data-benefit-bar]",
      headerNav: ".c-m-h__menu-wrapper",
      searchBox: "#l-search-box",
      wishlistCounter: ".wishlistCount",
      accountLayer: "[data-account-layer]",
      accountLayerTrigger: "[data-account-button-show]",
      menuLayer: "[data-menu-container]"
    };
  }
  get CSS_CUSTOMVARS() {
    return {
      jsHeightHeader: "--js-header-height",
      jsVh: "--vh"
    };
  }
  get CSS_CLASSNAMES() {
    return {
      burgerOpen: "menu-open",
      showMenu: "show-menu",
      activeLayersContainer: "active-layers",
      divider: "header-divider",
      open: "search-open"
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.burgerMenu = this.$component.querySelector(this.SELECTORS.burgerMenu);
    this.searchBtn = this.$component.querySelector(this.SELECTORS.searchBtn);
    this.menuIsOpen = false;
    this.headerHeight = this.$component.offsetHeight;
    this.layersContainer = this.$component.querySelector(
      this.SELECTORS.layersContainer
    );
    if (this.layersContainer != null) {
      this.layersContainer.style.transition = "opacity .5s ease-in-out .2s";
    }
    this.menuItems = [];
    this.hpHero = document.querySelector(this.SELECTORS.hpHero);
    this.benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    this.headerNav = document.querySelector(this.SELECTORS.headerNav);
    this.searchBox = document.querySelector(this.SELECTORS.searchBox);
    this.wishlistCounter = document.querySelectorAll(
      this.SELECTORS.wishlistCounter
    );
    this.trapFocusHandler = null;
    this.accountLayer = document.querySelector(this.SELECTORS.accountLayer);
    this.accountLayerTrigger = document.querySelector(
      this.SELECTORS.accountLayerTrigger
    );
    this.menuLayer = document.querySelector(this.SELECTORS.menuLayer);
  }
  render() {
    super.render();
    this.setCustomVar();
    this.listenResize();
    this.listenBurger();
    this.listenScroll();
    this.bindSearchBtnEvents();
    this.setMenuItems();
    this.bindEvents();
  }
  listenResize() {
    window.addEventListener("resize", () => {
      this.headerHeight = this.$component.offsetHeight;
      this.setMenuItems();
      this.setCustomVar();
    });
  }

  setMenuItems() {
    this.menuItems = [];
    let items = this.$component.querySelectorAll(this.SELECTORS.menuItems);
    if (items && items.length > 0) {
      items.forEach(item => {
        let menuItem = new MenuItem(item, this.layersContainer);
        this.menuItems.push(menuItem);
      });
    }
  }
  hideSecondLvlNav() {
    if (this.menuItems.length < 1) {
      return;
    }
    this.menuItems.forEach(menuItem => {
      menuItem.hidePanel();
    });
  }
  listenScroll() {
    if (this.hpHero != null && this.benefitBar != null) {
      window.addEventListener("scroll", () => {
        let heroHeight = this.hpHero.offsetHeight;
        let barHeight = this.benefitBar.offsetHeight;
        let totalScroll = heroHeight + barHeight;
        if (window.scrollY > totalScroll) {
          this.setDivider();
        }
      });
    } else {
      this.setDivider();
    }
  }
  setDivider() {
    this.$component.classList.add(this.CSS_CLASSNAMES.divider);
  }
  setCustomVar() {
    const root = document.documentElement;

    root.style.setProperty(
      this.CSS_CUSTOMVARS.jsHeightHeader,
      `${this.headerHeight}px`
    );
    root.style.setProperty(
      this.CSS_CUSTOMVARS.jsVh,
      `${window.innerHeight * 0.01}px`
    );
  }
  bindSearchBtnEvents() {
    if (this.searchBtn != null) {
      this.searchBtn.addEventListener("click", () => {
        this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.open);
      });
    }
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      this.searchBtn.setAttribute("aria-expanded", "true");
      this.searchBtn.disabled = true;
    });
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      this.searchBtn.setAttribute("aria-expanded", "false");
      this.searchBtn.disabled = false;
    });
  }
  listenBurger() {
    if (this.burgerMenu != null) {
      this.burgerMenu.addEventListener("click", () => {
        let trapFocusMenuHandler = null;
        const willBeOpen = !this.menuIsOpen;
        this.burgerMenu.setAttribute("aria-expanded", willBeOpen.toString());
        this.menuIsOpen
          ? removeTrapFocusOnModal(this.menuLayer, trapFocusMenuHandler)
          : (trapFocusMenuHandler = trapFocusOnModal(this.menuLayer));
        this.menuIsOpen
          ? this.$emit(this.$customEvents.MENU_EVENTS.hideMenu)
          : this.$emit(this.$customEvents.MENU_EVENTS.showMenu);
        this.menuIsOpen = !this.menuIsOpen;
      });
    }
  }

  updateWishlistCounter(qty) {
    if (this.wishlistCounter && this.wishlistCounter.length > 0) {
      this.wishlistCounter.forEach(counter => {
        counter.dataset.wlqty = qty;
        counter.textContent = qty;
        if (parseInt(qty, 10) > 0) {
          counter.style.display = "";
        } else {
          counter.style.display = "none";
        }
      });
    }
  }

  toggleAccountLayer(ctx) {
    ctx.accountLayer.classList.toggle("--opened");
    const isOpened = ctx.accountLayer.classList.contains("--opened");
    ctx.accountLayerTrigger.setAttribute("aria-expanded", isOpened.toString());
    if (isOpened) {
      ctx.accountLayerTrigger.setAttribute(
        "aria-label",
        ctx.accountLayerTrigger.dataset.labelClose
      );
      ctx.accountLayer.setAttribute("tabindex", "0");
      ctx.accountLayer.focus();
      ctx.trapFocusHandler = trapFocusOnModal(this.accountLayer);
    } else {
      ctx.accountLayerTrigger.setAttribute(
        "aria-label",
        ctx.accountLayerTrigger.dataset.labelOpen
      );
      ctx.accountLayer.removeAttribute("tabindex");
      removeTrapFocusOnModal(ctx.accountLayer, ctx.trapFocusHandler);
    }
  }

  a11yEvents(ctx) {
    if (ctx.accountLayerTrigger && ctx.accountLayer) {
      ctx.accountLayerTrigger.addEventListener("click", () => {
        ctx.toggleAccountLayer(ctx);
      });
      ctx.accountLayer.addEventListener("keydown", e => {
        if (e.key === "Escape") {
          ctx.accountLayer.classList.remove("--opened");
          ctx.accountLayerTrigger.setAttribute("aria-expanded", "false");
          ctx.accountLayerTrigger.setAttribute(
            "aria-label",
            ctx.accountLayerTrigger.dataset.labelOpen
          );

          ctx.accountLayer.removeAttribute("tabindex");
          removeTrapFocusOnModal(ctx.accountLayer, ctx.trapFocusHandler);
          ctx.accountLayerTrigger.focus();
        }
      });
    }
    this.menuLayer &&
      this.menuLayer.addEventListener("keydown", e => {
        if (e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          ctx.$emit(ctx.$customEvents.MENU_EVENTS.hideMenu);
          ctx.burgerMenu.focus();
        }
      });
  }

  handleLoginPopup() {
    const ctx = this;
    // Check if there's the login error query parameter
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loginError = urlParams.get("loginerror");
    if (`${loginError}` === "true") {
      ctx.toggleAccountLayer(ctx);
      const errorMessage = ctx.accountLayer.querySelector(
        ".error.error-message"
      );
      ctx.liveRegion.sayMessage(errorMessage.textContent || "");
      ctx.accountLayer.focus();
    }
  }

  bindEvents() {
    let scrollY;
    let self = this;
    this.$on(this.$customEvents.MENU_EVENTS.showMenu, () => {
      if (window.matchMedia("(max-width: 991px)").matches) {
        if (self.searchBtn.disabled) {
          self.searchBox.style.zIndex = "";
          self.headerNav.style.zIndex = "2";
        }
      }
      this.burgerMenu.classList.add(this.CSS_CLASSNAMES.burgerOpen);
      this.$component.classList.add(this.CSS_CLASSNAMES.showMenu);
      let barHeight = this.benefitBar.offsetHeight;
      scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
      document.body.style.position = "fixed";
      document.body.style.top = `-${barHeight}px`;
      document.body.style.width = "100%";
      this.setDivider();
      this.menuLayer.setAttribute("aria-hidden", "false");
      this.menuLayer.setAttribute("aria-modal", "true");
      this.menuLayer.setAttribute("tabindex", "0");
      this.menuLayer.focus();
    });
    this.$on(this.$customEvents.MENU_EVENTS.hideMenu, () => {
      if (window.matchMedia("(max-width: 991px)").matches) {
        self.headerNav.style.zIndex = "";
      }
      this.burgerMenu.classList.remove(this.CSS_CLASSNAMES.burgerOpen);
      this.$component.classList.remove(this.CSS_CLASSNAMES.showMenu);
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
      this.hideSecondLvlNav();
      this.menuLayer.setAttribute("aria-hidden", "true");
      this.menuLayer.setAttribute("aria-modal", "false");
      this.menuLayer.setAttribute("tabindex", "-1");
    });

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addedtowish,
      ({ event, payload }) => {
        if (payload.qty != null) {
          this.updateWishlistCounter(payload.qty);
        }
      }
    );

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.removedfromwish,
      ({ event, payload }) => {
        if (payload.qty != null) {
          this.updateWishlistCounter(payload.qty);
        }
      }
    );

    this.a11yEvents(this);
    this.handleLoginPopup();
  }
}
